import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { fetchBlogPost } from "../lib/api";

const BlogDetail = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    setLoading(true);
    fetchBlogPost(slug)
      .then(setPost)
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) {
    return <div className="container-wide py-32 font-mono-cust text-sm text-gray-500" data-testid="blog-detail-loading">Loading…</div>;
  }

  if (error || !post) {
    return (
      <div className="container-wide py-32" data-testid="blog-detail-error">
        <p className="font-mono-cust text-[11px] uppercase tracking-[0.3em] text-[#9F381A] mb-4">/ 404</p>
        <h1 className="font-heading text-4xl md:text-5xl tracking-tighter mb-8">Article not found.</h1>
        <Link to="/blog" className="inline-flex items-center gap-2 link-underline">
          <ArrowLeft className="w-4 h-4" /> Back to the journal
        </Link>
      </div>
    );
  }

  return (
    <article data-testid="blog-detail-page" className="container-wide py-16 md:py-24">
      <Link to="/blog" data-testid="blog-detail-back" className="inline-flex items-center gap-2 font-mono-cust text-[11px] uppercase tracking-[0.25em] text-gray-500 hover:text-[#9F381A] mb-12">
        <ArrowLeft className="w-3.5 h-3.5" /> Back to the journal
      </Link>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-16">
        <div className="lg:col-span-8">
          <p className="font-mono-cust text-[11px] uppercase tracking-[0.3em] text-[#9F381A] mb-6">/ {post.category}</p>
          <h1 data-testid="blog-detail-title" className="font-heading text-4xl md:text-5xl lg:text-6xl tracking-tighter leading-[0.95] mb-8">
            {post.title}
          </h1>
          <div className="flex items-center gap-6 text-sm text-gray-500 uppercase tracking-[0.2em]">
            <span>{post.author}</span>
            <span>·</span>
            <span>{post.date}</span>
            <span>·</span>
            <span>{post.read_time}</span>
          </div>
        </div>
      </div>

      <div className="relative h-[320px] md:h-[560px] overflow-hidden mb-16">
        <img src={post.cover} alt={post.title} loading="eager" decoding="async" className="w-full h-full object-cover" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-2">
          <p className="font-mono-cust text-[11px] uppercase tracking-[0.3em] text-gray-500 sticky top-32">/ Read</p>
        </div>
        <div className="lg:col-span-8 space-y-8">
          {post.content.map((para, i) => (
            <p key={i} className={`text-lg md:text-xl leading-relaxed ${i === 0 ? "font-editorial italic text-2xl md:text-3xl text-ink" : "text-ink-muted"}`}>
              {para}
            </p>
          ))}
        </div>
      </div>
    </article>
  );
};

export default BlogDetail;
